const events: Object[] = [
  {
    event_name: 'Actual sign ins',
    checked: true,
    event_icon_add: 'signin-employee',
  },
  {
    event_name: 'Actual sign outs',
    checked: true,
    event_icon_add: 'signout-employee',
  },
  {
    event_name: "Driver-employee calls",
    checked: true, 
    event_icon_add: "call-emp-events",
  },
  {
    event_name: "No Show",
    checked: true, 
    event_icon_add: "no-show-events",
  },
  {
    event_name: 'GPS Loss',
    checked: true,
    event_icon_add: 'no-gps',
  },
  {
    event_name: 'SOS ',
    checked: true,
    event_icon_add: 'sos',
  },
  {
    event_name: 'Over Speeding',
    checked: true,
    event_icon_add: 'over-speeding',
  },
  {
    event_name: 'Vehicle Stoppage',
    checked: true,
    event_icon_add: 'vehicle-stoppage',
  },
  {
    event_name: 'Network Loss',
    checked: false,
    event_icon_add: 'no-network-start',
  },
  {
    event_name: 'Device Off',
    checked: true,
    event_icon_add: 'device-off',
  },
  {
    event_name: "Planned Route",
    checked: true, 
    event_icon_add: "planned-route",
  },
  // {
  //   event_name: "Seat Belt Status",
  //   checked: true, 
  //   event_icon_add: "seat-belt-worn",
  // },
  {
    event_name:"Vehicle Arrived",
    checked: true,
    event_icon_add: "vehicle-arrived",
  },
  {
    event_name: "Seat Belt Status",
    checked: true, 
    event_icon_add: "seat-belt-worn",
  },
  // {
  //   event_name:"Vehicle Arrived",
  //   checked: true,
  //   event_icon_add: "vehicle-arrived",
  // }
];

export const Events = events;
